module.exports = __webpack_public_path__ + "img/resumemeter.ec4e18d8.svg";